export default "__VITE_ASSET__Efgj7GDj__"